import { GET_MARKETING_SLOT_BANNER_SUCCESS } from '../actionTypes/CartActionTypes';

export default function MarketingSlotBannerReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_MARKETING_SLOT_BANNER_SUCCESS:
            return action.zoneInfo || {};
        default:
            return state;
    }
}
